/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ClearPasswordDataParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('not-set')],
]);
export class ClearPasswordData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ClearPasswordDataParser.decode(input).map(res => new ClearPasswordData(res));
    }
    static unsafeDecode(input) {
        return ClearPasswordData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ClearPasswordDataParser.encode(data);
    }
    static schema() {
        return ClearPasswordDataParser.schema();
    }
}
